import { render, staticRenderFns } from "./PostSkeleton.vue?vue&type=template&id=48b19f19&scoped=true"
import script from "./PostSkeleton.vue?vue&type=script&lang=js"
export * from "./PostSkeleton.vue?vue&type=script&lang=js"
import style0 from "./PostSkeleton.vue?vue&type=style&index=0&id=48b19f19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b19f19",
  null
  
)

export default component.exports